import { render, staticRenderFns } from "./SalesTab.vue?vue&type=template&id=811136b2"
import script from "./SalesTab.vue?vue&type=script&lang=js"
export * from "./SalesTab.vue?vue&type=script&lang=js"
import style0 from "./SalesTab.vue?vue&type=style&index=0&id=811136b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports